import Wrapper from './wrapper';
import {
  IReportParams,
  ITrainingRevisionCreateParams,
  ITrainingRevisionListParams,
  ITrainingRevisionListResponse,
  IWrapper,
} from './types';

class TrainingRevision {
  wrapper: IWrapper;

  constructor(wrapper: Wrapper) {
    this.wrapper = wrapper;
  }

  list(params: ITrainingRevisionListParams) {
    return this.wrapper.client.get<ITrainingRevisionListResponse, ITrainingRevisionListResponse>(
      `data-pools/${this.wrapper.dataPoolId}/training-revisions/`,
      { params }
    );
  }

  create(data: ITrainingRevisionCreateParams) {
    return this.wrapper.client.post(
      `data-pools/${this.wrapper.dataPoolId}/training-revisions/?advanced=true`,
      data
    );
  }

  remove(id: string) {
    return this.wrapper.client.delete(
      `data-pools/${this.wrapper.dataPoolId}/training-revisions/${id}/?advanced=true`
    );
  }

  benchmark(id: string, params: IReportParams) {
    return this.wrapper.client.get(
      `data-pools/${this.wrapper.dataPoolId}/training-revisions/${id}/benchmark/`,
      { params }
    );
  }
}

export default TrainingRevision;
